import React, {useState} from 'react';
import {Button, Form, Input, Row} from "antd";
import {KeyOutlined, UserOutlined} from "@ant-design/icons";
import Checkbox from "antd/es/checkbox/Checkbox";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import NewPasswordForm from "../../components/Form/NewPasswordForm/NewPasswordForm";
import useActions from "../../hooks/useActions";

const Login = () => {
    const {login} = useActions()
    const [isChanged, setIsChanged] = useState(false);
    const {loading, isNewPassFormVisible} = useSelector(state => state?.login)

    const layout = {
        labelCol: {
            span: 4,
        },
        wrapperCol: {
            span: 18,
        },
    };

    const finishHandler = (values) => {
        if (!isChanged) return;
        login(values);
        setIsChanged(false);
    }

    const valuesChangeHandler = (setIsChanged) => {
        setIsChanged(true);
    }

    const validateMessages = {
        required: '${label} krävs!',
        types: {
            email: '${label} är inte en giltig e-post!',
            number: '${label} är inte ett giltigt nummer!',
        },
    };

    if (isNewPassFormVisible) {
        return <NewPasswordForm/>
    }

    return (
        <div className='container login-page'>
            <h2 style={{textAlign: 'center', maxWidth: '430px', width: '100%', fontSize: '20px'}}>Välkommen till Svenska Brasserier admin</h2>
            <p style={{textAlign: 'center', maxWidth: '430px', width: '100%', fontSize: '14px', color: '#898989'}}>Fyll i formuläret för att logga in</p>

            <Form {...layout}
                  className='login-form'
                  name="login"
                  onFinish={finishHandler}
                  onChange={() => valuesChangeHandler(setIsChanged)}
                  validateMessages={validateMessages}>
                <Form.Item
                    name='username'
                    label="Användarnamn"
                    labelCol={{ span: 24 }}
                    wrapperCol={{span: 24}}
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input prefix={<UserOutlined />}/>
                </Form.Item>

                <Form.Item
                    name='password'
                    label="Lösenord"
                    autoComplete='off'
                    labelCol={{ span: 24 }}
                    wrapperCol={{span: 24}}
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input type='password' width='100%' prefix={<KeyOutlined />}/>
                </Form.Item>

                <Form.Item
                    wrapperCol={{span: 24}}
                >
                   <Row justify='space-between'>
                       <Form.Item name="remember" valuePropName="checked" noStyle>
                           <Checkbox>Kom ihåg mig</Checkbox>
                       </Form.Item>
                   </Row>
                </Form.Item>

                <Form.Item
                    wrapperCol={{span: 24}}
                >
                    <Row justify='space-between' align='middle'>
                        <Button loading={loading} type="primary" htmlType="submit" className="login-form-button">
                            Logga in
                        </Button>
                    </Row>
                </Form.Item>
                <div className='stage_name' align='right'>
                    -{process.env.NAME}-
                </div>
            </Form>
        </div>
    );
};

export default Login;
